import { BASE_Action } from "../../Core/Redux/BaseAction";

export const ChangeShowOrHide = 'ChangeShowOrHide';
export const ChangeTitle = "ChangeTitle"

export type HeaderTickerAction =
    BASE_Action<typeof ChangeShowOrHide, boolean>
    | BASE_Action<typeof ChangeTitle, string>